import { Component, OnInit } from '@angular/core';
import { LocalStorage, LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'ngx-logout',
  template: ``,
})
export class LogoutComponent implements OnInit {
  @LocalStorage() token: string;
  @LocalStorage() role: string;
  @LocalStorage() companyType: string;

  constructor(private router: Router,
              private authService: AuthService,
              private sessionStorageService: SessionStorageService,
              private localStorageService: LocalStorageService) {
  }

  ngOnInit() {
    this.token = '';
    this.localStorageService.clear();
    this.sessionStorageService.clear();
    this.router.navigate(['auth', 'login']);
    // this.authService.logOutUser();
  }
}
